export const ProductCatalogType = {
  FirearmsAndAccessories: 'Firearms and Accessories',
  Ammunition: 'Ammunition',
  Silencers: 'Silencers',
  Merchandise: 'Merchandise',
} as const;

export default ProductCatalogType;
